import { Form } from "antd";
import { clsx } from "clsx";
import type { FormRef } from "rc-field-form/lib/interface";
import { forwardRef, useEffect, useState } from "react";
import { useQuestionnaire } from "../..";
import CorrectAndWrongWayModal from "./Components/CorrectAndWrongWayModal";
import QuestionnaireFormItem from "./Components/QuestionnaireFormItem";
import QuestionnaireSubmit from "./Components/QuestionnaireSubmit";

const QuestionnaireForm = forwardRef<FormRef, { className?: string; activeTab: "document" | "questionnaire" }>(({ className,activeTab }, ref) => {
	const { questions } = useQuestionnaire();
    const [form] = Form.useForm();

    const [documentRequiredQuestion, setDocumentRequiredQuestion] =
      useState<PopulatedQuestion | null>(null);
    const [disableSubmit, setDisableSubmit] = useState(true);

    const handleOpenCorrectAndWrongWayModal = (question: PopulatedQuestion) => {
      setDocumentRequiredQuestion(question);
    };

    const handleCloseCorrectAndWrongWayModal = () => {
      setDocumentRequiredQuestion(null);
    };

    const handleSubmitButtonState = () => {
      const unanswered = questions.filter(
        (q) =>
          q.is_root &&
          q.answer?.status !== "ANSWERED" &&
          q.answer?.status !== "APPROVED"
      );
      setDisableSubmit(unanswered.length > 0);
    };

    useEffect(() => {
      if (questions.length > 0) {
        handleSubmitButtonState();
      }
    }, [questions]);

    const documentQuestions = questions.filter(
      (q) => q.is_root && q.type === "DOCUMENT"
    );
    const nonDocumentQuestions = questions.filter(
      (q) => q.is_root && q.type !== "DOCUMENT"
    );

    return (
      <Form
        form={form}
        ref={ref}
        layout="vertical"
        initialValues={{ "disable-submit-continue-button": true }}
        className={clsx(
          "grid items-stretch gap-10 scrollbar-hidden w-full overflow-auto md:ps-4 md:pe-6 md:py-6 p-5 pt-3",
          className
        )}
      >
        {activeTab === "document" ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {documentQuestions.map((que, index) => (
              <QuestionnaireFormItem
                key={que._id}
                {...que}
                index={index}
                handleOpenCorrectAndWrongWayModal={handleOpenCorrectAndWrongWayModal}
              />
            ))}
          </div>
        ) : (
          nonDocumentQuestions.map((que, index) => (
            <div key={que._id} className="grid col-span-4">
              <QuestionnaireFormItem
                {...que}
                index={index}
                handleOpenCorrectAndWrongWayModal={handleOpenCorrectAndWrongWayModal}
              />
            </div>
          ))
        )}

        {questions.length > 0 && <QuestionnaireSubmit disabled={disableSubmit} />}

        <CorrectAndWrongWayModal
          open={!!documentRequiredQuestion}
          documentRequiredQuestion={documentRequiredQuestion}
          onClose={handleCloseCorrectAndWrongWayModal}
        />
      </Form>
    );
  }
);

export default QuestionnaireForm;

